import { SearchHistoryConstant } from "./SearchHistoryConstant";

const SearchHistoryAction = {};

SearchHistoryAction.getSearchHistoryData = ({to_date,from_date,limit,page,search_term,sorting}) => {
   
    return {
        type: SearchHistoryConstant.SEARCHHISTORY_SAGA, 
        payload: {
            to_date:to_date,
            from_date:from_date,
            search_term:search_term,
            limit:limit,
            page:page,
            sorting:sorting
        }
    }
};


export { SearchHistoryAction };